import React, { Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from "../components/homePage";
import LoaderIcon from "../components/loaderIcon";
import NewLocationBasePage from "../components/locationManagement/newLocation/NewLocationBasePage";
import SearchLocation from "../components/locationManagement/manageLocation/searchLocation";
import NewSearchSite from "../components/locationManagement/manageSite/searchSite";
import ViewLocation from "../components/locationManagement/manageLocation/viewLocation";
import EditLocation from "../components/locationManagement/manageLocation/editLocation";
import ErrorPage from "../components/errorPage";

const AppRoutes = (props) => {
  let { isAuthorized } = props;

  return (
    <div>
      <Router>
        <Suspense
          fallback={
            <div>
              <LoaderIcon />
            </div>
          }
        >
          <Routes>
            <Route exact path='/' element={<HomePage/>} />
            <Route exact path='/searchLocation' element={<SearchLocation/>} />
            <Route path='/errorPage' element={<ErrorPage/>} />
            <Route path='/newlocation' element={<NewLocationBasePage isAuthorized={isAuthorized}/>} />
            <Route path='/searchSite' element={<NewSearchSite isAuthorized={isAuthorized}/>} />
            <Route path='/viewLocation/:id' element={<ViewLocation isAuthorized={isAuthorized}/>} />
            <Route path='/editLocation/:id' component={<EditLocation isAuthorized={isAuthorized}/>} />
            <Route path='*' component={ShowError4040} />
          </Routes>
        </Suspense>
      </Router>
    </div>
  );
}

function ShowError4040() {
  return <div>Error 404</div>;
}
export default AppRoutes;
